import React, { FC, PropsWithChildren } from 'react';
import { IDrawerController } from './DrawerController';

export interface IDrawerContext {
    drawerController?: IDrawerController;
}

export const DrawerContext = React.createContext<IDrawerContext>({});

export const DrawerContextProvider: FC<PropsWithChildren<Required<IDrawerContext>>> = (props) => {
    const { children, ...rest } = props;

    return <DrawerContext.Provider value={rest}>{children}</DrawerContext.Provider>;
};
